import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { SoggettoPratica } from '../../../../common/models/tipologiche/soggetto-pratica';

export class FascicoloAccessoagliatti extends FascicoloFull {
  dataApertura: number;
  dataNotificaRichiesta: number;
  societa: SoggettoPratica;
  accolta: boolean;
  constructor() {
    super();
    this.dataApertura = + new Date();
    this.dataInizioFascicolo = + new Date();
  }
}
